import { render, staticRenderFns } from "./MotorbikesTable.vue?vue&type=template&id=2128d19b&"
import script from "./MotorbikesTable.vue?vue&type=script&lang=js&"
export * from "./MotorbikesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports